export default class TToast {
  config = {
    error: {
      heading: 'Error',
      text: '',
      position: 'top-right',
      loaderBg: '#ff6b6b',
      icon: 'error',
      hideAfter: 3500,
      stack: 6,
    },
    success: {
      heading: 'Success',
      text: '',
      position: 'top-right',
      loaderBg: '#ff990d',
      icon: 'success',
      hideAfter: 3500,
      stack: 6,
    },
  };

  constructor(custom = {}) {
    Object.assign(this, custom);
  };

  success(message) {
    TToast.toast(message, this.config.success);
  };

  error(message, props) {
    props = Object.assign(this.config.error, props || {});
    TToast.toast(message, props);
  };

  static toast(message, props) {
    const toast = {
      text: message,
    };
    $.toast(Object.assign(props, toast));
  };
}
